import React from 'react';
import PropTypes from 'prop-types';

import LoaderSVG from '../../../assets/loader.svg';

import styles from '../../styles/views/components/Loader.module.scss';

const Loader = ({ height, width }) => (
  <div className={styles.spinner}>
    <LoaderSVG width={width} height={height} />
  </div>
);

Loader.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

Loader.defaultProps = {
  height: '100px',
  width: '100px',
};

export default Loader;
